import {watch} from 'vue';
import {useRoute} from 'vue-router';

import {routes} from '@/routes';

export function useThemeColor() {
  const route = useRoute();

  const setThemeColor = (color) => {
    const metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag.setAttribute('content', color);
    } else {
      const newMetaTag = document.createElement('meta');
      newMetaTag.setAttribute('name', 'theme-color');
      newMetaTag.setAttribute('content', color);
      document.head.appendChild(newMetaTag);
    }
  };

  watch(
    route,
    (newRoute) => {
      switch (newRoute.name) {
        case routes.ONBOARDING:
          setThemeColor('#040325');
          break;
        default:
          setThemeColor('#FFFFFF');
          break;
      }
    },
    {immediate: true},
  );
}
